import { IAttributeRef } from '@models/IFunctionality';
import { IRecord, IRecords } from '@models/IRecord';
import FunctionalityRecordDetail from '../records/FunctionalityRecordDetail';
import ModelAttributeCard from '@components/model/details/ModelAttributeCard';
import { Chip } from '@destination/components';

export interface IFunctionalityAttributeDetail {
  attribute: IAttributeRef;
  records: IRecords;
}

export const FunctionalityAttributeDetail = ({
  attribute,
  records
}: IFunctionalityAttributeDetail) => {
  const mustShowBody = (record: IRecord) => {
    return record.type != 'boolean';
  };

  const EqualChip = ({
    label,
    width = 120
  }: {
    label: string;
    width?: number;
  }) => {
    return (
      <div className={`w-[${width}px]`}>
        <Chip label={label} className="mr-4" />
      </div>
    );
  };

  const Body = () => {
    const recordName = attribute.$ref.split('/').pop();
    if (!recordName) return null;

    const record = records[recordName];
    if (!record) return null;

    return (
      <div data-testid="functionality-attribute-detail-body">
        {mustShowBody(record as IRecord) ? (
          <FunctionalityRecordDetail
            name={recordName}
            record={record as IRecord}
            records={records}
          />
        ) : (
          <ModelAttributeCard
            variant="LIGHT"
            title={titleComponent(recordName, record as IRecord)}
          ></ModelAttributeCard>
        )}
      </div>
    );
  };

  const titleComponent = (key: string, record: IRecord) => (
    <div className="flex items-center w-full">
      <EqualChip label={record.type} />
      <div className="tw-text-base">{key}</div>
    </div>
  );

  return (
    <div data-testid="functionality-attribute-detail">
      <Body />
    </div>
  );
};
